import * as React from 'react'
import PropTypes from 'prop-types'
import Button from '@/components/Button'
import isExternalLink from '@/utils/isExternalLink'
import resolveAssetURL from '@/utils/resolveAssetURL'
import isPdf from '@/utils/isPdf'

import {
  Container,
  TextContainer,
  Action
} from './style'

const ArticleBlockCTA = ({
  to = '',
  label = '',
  target = '_self',
  action = '',
  tracking = true
}) => {
  return (
    <Container>
      <TextContainer>
        <Action>
          <Button ctaTracking={ tracking } onClick={ action } to={ isPdf(to) ? resolveAssetURL(to) : to } target={ isExternalLink(to) ? '_blank' : '_self' }>{label}</Button>
        </Action>
      </TextContainer>
    </Container>
  )
}

ArticleBlockCTA.propTypes = {
  to: PropTypes.string,
  label: PropTypes.string
}

export default ArticleBlockCTA
